import { InfoBarStringTemplates } from './sharingTipIdToInfoBarString';
import { SharingTipId } from '../../types/sharingTipId';
import { assertNever } from 'owa-assert';
import strings from 'owa-strings/owa-mail-strings';

export function getActionRecommendations(
    sharingTipId: SharingTipId
): InfoBarStringTemplates | null {
    switch (sharingTipId) {
        case SharingTipId.noPermissionToShare:
        case SharingTipId.noPermissionToShareExternally:
        case SharingTipId.externalRecipientCSL:
            return {
                singleFile: strings.SuggestAttachingACopySingleText,
                multipleFiles: strings.SuggestActionForMultipleFilesCannotShareText,
            };
        case SharingTipId.getSharingInfoFailed:
        case SharingTipId.linkHasExpired:
        case SharingTipId.linkWillExpire:
        case SharingTipId.noPermissionSet:
        case SharingTipId.sharingWithLargeDL:
            return null;
        default:
            return assertNever(sharingTipId);
    }
}
